import React, { useState, useEffect, useReducer } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AxesDefinition from './AxesDefinition'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Duplicates from './Duplicates'
import FactSourceColumns from './FactSourceColumns'
import FactSourceFirstRow from './FactSourceFirstRow'
import LinearProgress from '@mui/material/LinearProgress'
import MeasuresDefinition from './MeasuresDefinition'
import SelectFiles from './SelectFiles'
import Summary from './Summary'
import TableDefinition from './TableDefinition'
import { getPreviewData, readTablesFromExcelFiles, createNewWizardFile, editWizardFile, getDatabaseJobFiles } from '../../../../actions/dbFunctionsActions'
import { uploadFileData } from '../../../../actions/userActions'

function NewWizardDialog(props) {
    const [wizardStep, setWizardStep] = useState('')
    const [headerRow, setHeaderRow] = useState(0)
    const [factSourceFirstRow, setFactSourceFirstRow] = useState(-1)
    const [tableDefinition, setTableDefinition] = useState({
        "tableHasHeader": false,
        "namedColumns": false
    })
    const [previewData, setPreviewData] = useState([])
    const [externalTabData, setExternalTabData] = useState([])
    const [globalFiles, setGlobalFiles] = useState([])
    const [zipFileId, setZipFileId] = useState('')
    const [textQualifier, setTextQualifier] = useState(-1)
    const [sourceFiles, setSourceFiles] = useState([])
    const [textDelimiter, setTextDelimiter] = useState(0)
    const [customDelimiter, setCustomDelimiter] = useState('')
    const [selectedExcelTables, setSelectedExcelTables] = useState([])
    const [factsColumnRanges, setFactsColumnRanges] = useState([])
    const [dimensions, setDimensions] = useState([])
    const [builtMeasures, setBuiltMeasures] = useState([])
    const [userMeasures, setUserMeasures] = useState([])
    const [aggregationSelections, setAggregationSelections] = useState([])
    const [selectedDimension, setSelectedDimension] = useState({ "id":  -1, "name": "", "outputFormat": [], "ranges": [], "segments": [], "type": 1 })
    const [wizardFileName, setWizardFileName] = useState('')
    const [wizardFileId, setWizardFileId] = useState(-1)
    const [validFileName, setValidFileName] = useState(false)
    const [, forceUpdate] = useReducer(x => x + 1, 0)

    const UI_COLORS = {
        REGULAR: "#ffffff",
        ROW_HIGHLIGHT: "#ffeba5",
        FACT_COLUMN_HIGHLIGHT: "#ddf1f1",
        GRID_HIGHLIGHT: "#0078D7",
        MANDATORY_UNDEFINED: "#F08080",
        USER_UNDEFINED: "#ADD8E6",
        MANDATORY_DEFINED: "#FFA07A",
        USER_DEFINED: "#87CEFA"
    }

    const getExcelColoringStyles = (() => {
        return null
    })()

    // trigger on component mount
    useEffect(() => {
        if (props.wizardStep !== null && props.wizardStep !== undefined) {
            setWizardStep(props.wizardStep)
        }

        if (props.globalFiles && props.globalFiles.length > 0) {
            let globals = []
            for (let x = 0; x < props.globalFiles.length; x++) {
                let individualJobFileData = JSON.parse(props.globalFiles[x]["jobFileData"])
                globals.push(individualJobFileData)
            }
            setGlobalFiles(globals)
        }

        if (props.headerRow !== headerRow) {
            setHeaderRow(headerRow)
        }
        
        if (props.factSourceFirstRow !== factSourceFirstRow) {
            setFactSourceFirstRow(props.factSourceFirstRow)
        }

        if (props.tableDefinition.tableHasHeader !== tableDefinition.tableHasHeader || props.tableDefinition.namedColumns !== tableDefinition.namedColumns) {
            setTableDefinition(props.tableDefinition)
        }

        if (props.factsColumnRanges !== null &&  props.factsColumnRanges !== undefined && props.factsColumnRanges.length !== factsColumnRanges.length) {
            setFactsColumnRanges(props.factsColumnRanges)
        }

        if (props.dimensions !== null &&  props.dimensions !== undefined && props.dimensions.length !== dimensions.length) {
            setDimensions(props.dimensions)
        }

        if (props.aggregationSelections && props.aggregationSelections.length !== aggregationSelections.length) {
            setAggregationSelections(props.aggregationSelections)
        }

        if (props.selectedDimension && props.selectedDimension.id !== selectedDimension.id) {
            setSelectedDimension(props.selectedDimension)
        }

        if (props.wizardFileName && props.wizardFileName !== wizardFileName) {
            setWizardFileName(props.wizardFileName)
        }

        if (props.wizardFileId !== wizardFileId) {
            setWizardFileId(props.wizardFileId)
        }
    }, [])

    useEffect(() => {
        if (props.wizardStep !== null && props.wizardStep !== undefined && props.wizardStep !== wizardStep) {
            setWizardStep(props.wizardStep)
        }
    }, [props.wizardStep])

    useEffect(() => {
        if (props.globalFiles && props.globalFiles.length > 0 && props.globalFiles.length !== globalFiles.length) {
            let globals = []
            for (let x = 0; x < props.globalFiles.length; x++) {
                let individualJobFileData = JSON.parse(props.globalFiles[x]["jobFileData"])
                globals.push(individualJobFileData)
            }
            setGlobalFiles(globals)
        }
    }, [props.globalFiles])

    useEffect(() => {
        if (props.headerRow !== headerRow) {
            setHeaderRow(props.headerRow)
        }
    }, [props.headerRow])

    useEffect(() => {
        if (props.factSourceFirstRow !== factSourceFirstRow) {
            setFactSourceFirstRow(props.factSourceFirstRow)
        }
    }, [props.factSourceFirstRow])

    useEffect(() => {
        if (props.tableDefinition.tableHasHeader !== tableDefinition.tableHasHeader || props.tableDefinition.namedColumns !== tableDefinition.namedColumns) {
            setTableDefinition(props.tableDefinition)
        }
    }, [props.tableDefinition])

    useEffect(() => {
        if (props.factsColumnRanges !== null &&  props.factsColumnRanges !== undefined && props.factsColumnRanges.length !== factsColumnRanges.length) {
            setFactsColumnRanges(props.factsColumnRanges)
        }
    }, [props.factsColumnRanges])

    useEffect(() => {
        if (props.dimensions !== null &&  props.dimensions !== undefined && props.dimensions.length !== dimensions.length) {
            setDimensions(props.dimensions)
        }
    }, [props.dimensions])

    useEffect(() => {
        if (props.aggregationSelections && props.aggregationSelections.length !== aggregationSelections.length) {
            setAggregationSelections(props.aggregationSelections)
        }
    }, [props.aggregationSelections])

    useEffect(() => {
        if (props.selectedDimension && props.selectedDimension.id !== selectedDimension.id) {
            setSelectedDimension(props.selectedDimension)
        }
    }, [props.selectedDimension])
    
    useEffect(() => {
        if (props.wizardFileName && props.wizardFileName !== wizardFileName) {
            setWizardFileName(props.wizardFileName)
        }
    }, [props.wizardFileName])

    useEffect(() => {
        if (props.wizardFileId !== wizardFileId) {
            setWizardFileId(props.wizardFileId)
        }
    }, [props.wizardFileId])

    useEffect(() => {
        if (props.factSourceFirstRow !== factSourceFirstRow) {
            setFactSourceFirstRow(props.factSourceFirstRow)
        }
    }, [props.factSourceFirstRow])

    function renderSubHeader() {
        switch (wizardStep) {
            case 'table-definition':
                return 'Please define the source table properties here.'
            case 'fact-source-first-row':
                return 'Use this page to define the first row that contains facts.'
            case 'fact-source-columns':
                return 'Use this page to define the columns of the fact source.'
            case 'select-files':
                return 'Select the files to be used in the import.'
            case 'axes-definition':
                return 'Use this page to define measures, dimensions, and segments.'
            case 'measures-definition':
                return 'Use this page to define characteristics about measures.'
            case 'duplicates':
                return 'Use this page to choose the dimension in which duplicates may appear.'
            default:
                return ''
        }
    }

    /**
     * isBackButtonDisabled
     * * Reads the current wizard step to determine if the back button needs to be disabled
     * @returns {bool} If we should disable the back button or not
     */
    function isBackButtonDisabled() {
        switch (wizardStep) {
            case 'select-files':
            case 'saving-wizard-file':
            case 'loading-wizard-file':
                return true
            default:
                return false
        }
    }

    /**
     * isNextButtonDisabled
     * * Reads the current wizard step to determine if the next button needs to be disabled
     * @returns {bool} If we should disable the next button or not
     */
    function isNextButtonDisabled() {
        switch (wizardStep) {
            case 'select-files': {
                if (doTheSourceFilesContainExcel(sourceFiles)) {
                    return selectedExcelTables.length === 0
                }
                return sourceFiles.length === 0
            }
            case 'fact-source-columns': {
                return factsColumnRanges.length === 0
            }
            case 'axes-definition': {
                return !doEachDimensionHaveAtLeastOneRangeAndEachSegmentHasAtLeastOneRange(dimensions)
            }
            case 'measures-definition': {
                let bothMeasureGroups = builtMeasures.concat(userMeasures)
                return hasDuplicates(bothMeasureGroups)
            }
            case 'summary':
            case 'saving-wizard-file':
            case 'loading-wizard-file':
                return true
            case 'table-definition': {
                return previewData.length === 0
            }
            default:
                return false
        }
    }

    /**
     * isFinishButtonDisabled
     * * Reads the current wizard step to determine if the finish button needs to be disabled
     * @returns {bool} If we should disable the finish button or not
     */
    function isFinishButtonDisabled() {
        switch (wizardStep) {
            case 'summary': {
                return wizardFileName.trim().length === 0 || validFileName
            }
            default:
                return true
        }
    }

    function doTheSourceFilesContainExcel(files) {
        for (let fileItr = 0; fileItr < files.length; fileItr++) {
            if (files[fileItr]["name"].toLowerCase().includes(".xlsx") || files[fileItr]["name"].toLowerCase().includes(".xls")) {
                return true
            }
        }

        return false
    }

    /**
     * formatExcelData
     * * Format the API preview data into a format the excel plugin would perfer
     * @param {Array} previewData - Data from API
    */
    function formatExcelData(previewData, tableHasHeader) {
        let formattedExcelData = []
        previewData.map((d, i) => {
            formattedExcelData.push({ name: d["tabName"], data: reworkPreviewDataForExcelPlugin(d["previewData"], tableHasHeader) })
        })
        return formattedExcelData
    }

    /**
     * reworkPreviewDataForExcelPlugin
     * * We are now adopting this new Excel front end plugin for our grids As a result, we need to format our data a little differently
     * * Previously like: [["Geography","Time","Product","Custom Category Value","Dollar Sales","Unit Sales"],["Total US - Multi Outlet","Calendar Year 2017 Ending 01-07-18","CHOCOLATE","CHOCOLATE","399,069,719 ","194,095,752"]]
     * * New Output: [{"0":"Geography","1":"Time","2":"Product","3":"Custom Category Value","4":"Dollar Sales","5":"Unit Sales"},{"0":"Total US - Multi Outlet","1":"Calendar Year 2017 Ending 01-07-18","2":"CHOCOLATE","3":"CHOCOLATE","4":"399,069,719 ","5":"194,095,752"}]
     * @param {array} dataFromPreview - Data like from the "Previously Like" part of the description
    */
    function reworkPreviewDataForExcelPlugin(dataFromPreview, tableHasHeader) {
        let transformedData = dataFromPreview.map(row => {
            if (!tableHasHeader) {
                return row.reduce((obj, value, index) => {
                    obj[index] = value
                    return obj
                }, {})
            } else if (tableHasHeader && doesThisRowHaveDataInEverySingleColumn(row)) {
                return row.reduce((obj, value, index) => {
                    obj[index] = value
                    return obj
                }, {})
            }
        })
        return transformedData
    }

    function getMaximumIndexFromData(dataFromPreview) {
        let rtnVal = -1
        for (let x = 0; x < dataFromPreview.length; x++) {
            let current = dataFromPreview[x]
            if (Object.keys(current).length > rtnVal) { rtnVal = Object.keys(current).length }
        }
        return rtnVal
    }

    function renderCurrentStep(files) {
        switch (wizardStep) {
            case 'select-files':
                return <SelectFiles
                    uiColors={UI_COLORS}
                    jobFiles={files}
                    readTablesFromExcelFiles={props.readTablesFromExcelFiles}
                    onSave={(data) => {
                        setZipFileId(data["zipFileId"])
                        setTextQualifier(data["textQualifier"])
                        setSourceFiles(data["sourceFiles"])
                        setTextDelimiter(data["textDelimiter"])
                        setCustomDelimiter(data["customDelimiter"])
                        setSelectedExcelTables(data["selectedExcelTables"])
                    }} />
            case 'table-definition':
                return <TableDefinition
                    uiColors={UI_COLORS}
                    excelColors={getExcelColoringStyles}
                    tableDefinition={tableDefinition}
                    headerRow={headerRow}
                    previewData={previewData}
                    zipFileId={zipFileId}
                    textQualifier={textQualifier}
                    sourceFiles={sourceFiles}
                    textDelimiter={textDelimiter}
                    customDelimiter={customDelimiter}
                    selectedExcelTables={selectedExcelTables}
                    getPreviewData={props.getPreviewData}
                    getExcelColumnName={getExcelColumnName}
                    formatExcelData={formatExcelData}
                    doesThisRowHaveDataInEverySingleColumn={doesThisRowHaveDataInEverySingleColumn}
                    doesThisObjectKeyRowHaveDataInEverySingleColumn={doesThisObjectKeyRowHaveDataInEverySingleColumn}
                    getMaximumIndexFromData={getMaximumIndexFromData}
                    onSave={(tableDefinition) => {
                        setTableDefinition({
                            "tableHasHeader": tableDefinition["tableHasHeader"],
                            "namedColumns": tableDefinition["namedColumns"]
                        })
                        setPreviewData(tableDefinition["tabData"])
                        setHeaderRow(tableDefinition["headerRow"])
                        setExternalTabData(tableDefinition["externalTabData"])
                    }}
                />
            case 'fact-source-first-row':
                return <FactSourceFirstRow
                    uiColors={UI_COLORS}
                    excelColors={getExcelColoringStyles}
                    headerRow={headerRow}
                    factSourceFirstRow={factSourceFirstRow}
                    previewData={previewData}
                    namedColumns={tableDefinition["namedColumns"]}
                    tableHasHeader={tableDefinition["tableHasHeader"]}
                    getExcelColumnName={getExcelColumnName}
                    formatExcelData={formatExcelData}
                    doesThisRowHaveDataInEverySingleColumn={doesThisRowHaveDataInEverySingleColumn}
                    doesThisObjectKeyRowHaveDataInEverySingleColumn={doesThisObjectKeyRowHaveDataInEverySingleColumn}
                    getMaximumIndexFromData={getMaximumIndexFromData}
                    onSave={(data) => setFactSourceFirstRow(data["rowIndex"])}
                />
            case 'fact-source-columns':
                return <FactSourceColumns
                    uiColors={UI_COLORS}
                    excelColors={getExcelColoringStyles}
                    previewData={previewData}
                    tableDefinition={tableDefinition}
                    headerRow={headerRow}
                    factSourceFirstRow={factSourceFirstRow}
                    tableHasHeader={tableDefinition["tableHasHeader"]}
                    factsColumnRanges={factsColumnRanges}
                    formatExcelData={formatExcelData}
                    getExcelColumnName={getExcelColumnName}
                    doesThisRowHaveDataInEverySingleColumn={doesThisRowHaveDataInEverySingleColumn}
                    doesThisObjectKeyRowHaveDataInEverySingleColumn={doesThisObjectKeyRowHaveDataInEverySingleColumn}
                    getMaximumIndexFromData={getMaximumIndexFromData}
                    onSave={(data) => {
                        setFactsColumnRanges(data["factsColumnRanges"])
                        forceUpdate()
                    }} />
            case 'axes-definition':
                return <AxesDefinition
                    uiColors={UI_COLORS}
                    excelColors={getExcelColoringStyles}
                    previewData={previewData}
                    tableDefinition={tableDefinition}
                    headerRow={headerRow}
                    factSourceFirstRow={factSourceFirstRow}
                    dimensions={dimensions}
                    tableHasHeader={tableDefinition["tableHasHeader"]}
                    externalTabData={externalTabData}
                    factsColumnRanges={factsColumnRanges}
                    getExcelColumnName={getExcelColumnName}
                    formatExcelData={formatExcelData}
                    doesThisRowHaveDataInEverySingleColumn={doesThisRowHaveDataInEverySingleColumn}
                    doesThisObjectKeyRowHaveDataInEverySingleColumn={doesThisObjectKeyRowHaveDataInEverySingleColumn}
                    getMaximumIndexFromData={getMaximumIndexFromData}
                    onSave={(data) => {
                        setDimensions(data)
                        forceUpdate()
                    }} />
            case 'measures-definition':
                return <MeasuresDefinition
                    uiColors={UI_COLORS}
                    excelColors={getExcelColoringStyles}
                    previewData={previewData}
                    headerRow={headerRow}
                    factSourceFirstRow={factSourceFirstRow}
                    factsColumnRanges={factsColumnRanges}
                    dimensions={dimensions}
                    aggregationSelections={aggregationSelections}
                    tableHasHeader={tableDefinition["tableHasHeader"]}
                    doesThisRowHaveDataInEverySingleColumn={doesThisRowHaveDataInEverySingleColumn}
                    onSave={(data) => {
                       setBuiltMeasures(data["builtMeasures"])
                       setUserMeasures(data["userMeasures"])
                       setAggregationSelections(data["aggregationSelections"])
                       forceUpdate()
                    }}
                />
            case 'duplicates':
                return <Duplicates
                    uiColors={UI_COLORS}
                    dimensions={dimensions}
                    selectedDimension={selectedDimension}
                    onSave={(data) => {
                        setSelectedDimension(data)
                        forceUpdate()
                    }}
                />
            case 'summary':
                return <Summary
                    jobFiles={files}
                    dimensions={dimensions}
                    previewData={previewData}
                    tableDefinition={tableDefinition}
                    headerRow={headerRow}
                    factSourceFirstRow={factSourceFirstRow}
                    factsColumnRanges={factsColumnRanges}
                    wizardFileName={wizardFileName}
                    onSave={(data, valid) => {
                        setWizardFileName(data)
                        setValidFileName(valid)
                    }}
                />
            case 'saving-wizard-file':
            case 'loading-wizard-file':
                return <Box sx={{ width: '100%' }}>
                    <LinearProgress />
              </Box>
            default:
                return null
        }
    }

    /**
     * handleNextButtonClick
     * * For when the "Next" button is pressed
     * @param {Event} e - Click event object
     */
    function handleNextButtonClick(e) {
        e.preventDefault()
        switch (wizardStep) {
            case 'select-files':
                setWizardStep('table-definition')
                break
            case 'table-definition':
                setWizardStep('fact-source-first-row')
                break
            case 'fact-source-first-row':
                setWizardStep('fact-source-columns')
                break
            case 'fact-source-columns':
                setWizardStep('axes-definition')
                break
            case 'axes-definition':
                setWizardStep('measures-definition')
                break
            case 'measures-definition':
                setWizardStep('duplicates')
                break
            case 'duplicates':
                setWizardStep('summary')
                break
            default:
                return
        }
    }

    /**
     * handleBackButtonClick
     * * For when the "Back" button is pressed
     * @param {Event} e - Click event object
     */
    function handleBackButtonClick(e) {
        e.preventDefault()
        switch (wizardStep) {
            case 'table-definition': 
                setWizardStep('select-files')
                setPreviewData([])
                break
            case 'fact-source-first-row':
                setWizardStep('table-definition')
                break
            case 'fact-source-columns':
                setWizardStep('fact-source-first-row')
                break
            case 'axes-definition':
                setWizardStep('fact-source-columns')
                break
            case 'measures-definition':
                setWizardStep('axes-definition')
                break
            case 'measures-definition':
                setWizardStep('axes-definition')
                break
            case 'duplicates':
                setWizardStep('measures-definition')
                break
            case 'summary':
                setWizardStep('duplicates')
                break
            default:
                return
        }
    }

    /**
     * handleBackButtonClick
     * * For when the "Back" button is pressed
     * @param {Event} e - Click event object
     */
    async function handleFinishButtonClick(e) {
        e.preventDefault()

        setWizardStep('saving-wizard-file')

        let alteredWizardFileName = wizardFileName
        if (!alteredWizardFileName.toLowerCase().endsWith('.json')) {
            alteredWizardFileName = alteredWizardFileName + '.json'
        }

        let data = {
            name: alteredWizardFileName,
            size: 0
        }

        let dbUploadFileReq = await props.uploadFileData(data)
        let dbUploadFileResp = await dbUploadFileReq.json()

        let objectToSendToApi = {
            "package": {
                "fileName": data["name"],
                "tableDefinition": tableDefinition,
                "headerRow": factSourceFirstRow,
                "factsColumnRanges": factsColumnRanges,
                "dimensions": dimensions,
                "builtMeasures": builtMeasures,
                "userMeasures": userMeasures,
                "aggregationSelections": aggregationSelections,
                "selectedDimension": selectedDimension,
                "wizardFileId": wizardFileId
            },
            "fileUpload": dbUploadFileResp
        }

        console.log("***Sending To Azure Blob***")
        console.log(JSON.stringify(objectToSendToApi))

        if (wizardFileId === -1) {
            props.createNewWizardFile(objectToSendToApi).then((resp) => {
                if (resp.status !== 200) {
                    throw new Error()
                } else {
                    // Purge all data on close since this component technically doesn't really "unmount" when we think it does
                    setWizardStep('')
                    setTableDefinition({
                        "tableHasHeader": false,
                        "namedColumns": false
                    })
                    setPreviewData([])
                    setHeaderRow(0)
                    setFactSourceFirstRow(-1)
                    setZipFileId('')
                    setTextQualifier(-1)
                    setSourceFiles([])
                    setTextDelimiter(0)
                    setCustomDelimiter('')
                    setSelectedExcelTables([])
                    setFactsColumnRanges([])
                    setWizardFileName('')
                    props.getDatabaseJobFiles()
    
                    // Fire off external onClose
                    props.onClose()
                }
            })
            .catch((ex) => {
                console.error(ex)
            })
        } else {
            props.editWizardFile(objectToSendToApi).then((resp) => {
                if (resp.status !== 200) {
                    throw new Error()
                } else {
                    // Purge all data on close since this component technically doesn't really "unmount" when we think it does
                    setWizardStep('')
                    setTableDefinition({
                        "tableHasHeader": false,
                        "namedColumns": false
                    })
                    setPreviewData([])
                    setHeaderRow(0)
                    setFactSourceFirstRow(-1)
                    setZipFileId('')
                    setTextQualifier(-1)
                    setSourceFiles([])
                    setTextDelimiter(0)
                    setCustomDelimiter('')
                    setSelectedExcelTables([])
                    setFactsColumnRanges([])
                    setWizardFileName('')
                    props.getDatabaseJobFiles()
    
                    // Fire off external onClose
                    props.onClose()
                }
            })
            .catch((ex) => {
                console.error(ex)
            })
        }
    }

    function toNormalCase(str) {
        // Replace hyphens with whitespace
        let stringWithSpaces = str.replace(/-/g, ' ')
        
        // Convert each word to normal case
        return stringWithSpaces.replace(/\b\w/g, function(char) {
            return char.toUpperCase()
        })
    }

    function getExcelColumnName(columnNumber) {
        let columnName = ""
    
        while (columnNumber > 0) {
            const modulo = (columnNumber - 1) % 26
            columnName = String.fromCharCode('A'.charCodeAt(0) + modulo) + columnName
            columnNumber = Math.floor((columnNumber - modulo) / 26)
        }
    
        return columnName
    }

    function doEachDimensionHaveAtLeastOneRangeAndEachSegmentHasAtLeastOneRange(dimensionsData) {
        let rtnVal = true

        for (let x = 0; x < dimensionsData.length; x++) {
            if (dimensionsData[x]["ranges"].length === 0 && dimensionsData[x]["outputFormat"].length === 0) {
                rtnVal = false
            }

            for (let y = 0; y < dimensionsData[x]["segments"].length; y++) {
                if (dimensionsData[x]["segments"][y]["ranges"].length === 0 && dimensionsData[x]["segments"][y]["outputFormat"].length === 0) {
                    rtnVal = false
                }
            }
        }

        if (dimensionsData.length < 4) {
            rtnVal = false
        }

        return rtnVal
    }

    /**
     * doesThisRowHaveDataInEverySingleColumn
     * * Checks to see if this is a full row
     * @param {Array} tabInfoRow - Row of data
     * @returns {boolean}
     */
    function doesThisRowHaveDataInEverySingleColumn(tabInfoRow) {
        let rtnVal = true
        let cellsWithData = 0

        tabInfoRow.forEach((rowData, rowIndex) => {
            if (rowData !== null && rowData !== undefined) {
                cellsWithData++
            }
        })

        if (cellsWithData <= 1) {
            rtnVal = false
        }

        return rtnVal
    }

    /**
     * doesThisObjectKeyRowHaveDataInEverySingleColumn
     * * Checks to see if this is a full row
     * @param {Object} tabInfoRow - Row of data
     * @returns {boolean}
     */
    function doesThisObjectKeyRowHaveDataInEverySingleColumn(tabInfoRow) {
        let rtnVal = true
        let cellsWithData = 0
        let row = []
        Object.keys(tabInfoRow).forEach((keyName, index) => {
            row.push(tabInfoRow[keyName])
        })

        row.forEach((rowData, rowIndex) => {
            if (rowData !== null && rowData !== undefined) {
                cellsWithData++
            }
        })

        if (cellsWithData <= 1) {
            rtnVal = false
        }

        return rtnVal
    }

    function hasDuplicates(array) {
        let set = new Set()
        let lowerCaseItems = new Set()
    
        for (let item of array) {
            let lowerCaseItem = item.toLowerCase()
    
            if (lowerCaseItems.has(lowerCaseItem)) {
                return true
            }
    
            lowerCaseItems.add(lowerCaseItem)
        }
    
        return false
    }

    return <Dialog
        open={wizardStep !== ''}
        fullScreen
        maxWidth="xl">
            <CloseIcon onClick={(e) => {
                e.preventDefault()

                // Purge all data on close since this component technically doesn't really "unmount" when we think it does
                setWizardStep('')
                setTableDefinition({
                    "tableHasHeader": false,
                    "namedColumns": false
                })
                setPreviewData([])
                setHeaderRow(0)
                setFactSourceFirstRow(-1)
                setZipFileId('')
                setTextQualifier(-1)
                setSourceFiles([])
                setTextDelimiter(0)
                setCustomDelimiter('')
                setSelectedExcelTables([])
                setFactsColumnRanges([])
                setWizardFileName('')

                // Fire off external onClose
                props.onClose()
            }} className="closePoup" />
            <DialogTitle>{toNormalCase(wizardStep)}</DialogTitle>
            <DialogContent>
                <DialogContentText>{renderSubHeader()}</DialogContentText>
                {renderCurrentStep(globalFiles)}
            </DialogContent>
            <DialogActions disableSpacing={false} style={{ justifyContent: "center" }}>
                <Button className="btn" variant="contained" disabled={isBackButtonDisabled()} onClick={handleBackButtonClick}>
                    &lt; Back
                </Button>
                <Button className="btn" variant="contained" disabled={isNextButtonDisabled()} onClick={handleNextButtonClick}>
                    Next &gt;
                </Button>
                <Button className="btn" variant="contained" disabled={isFinishButtonDisabled()} onClick={handleFinishButtonClick}>
                    Finish
                </Button>
            </DialogActions>
        </Dialog>
}

function mapStateToProps(state) {
    return {
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ getPreviewData, readTablesFromExcelFiles, createNewWizardFile, uploadFileData, editWizardFile, getDatabaseJobFiles }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewWizardDialog)